/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Component, OnInit } from '@angular/core';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

//import { Animations } from '../../global/animations';
import { ConfirmDialogComponent } from '../../global/confirm-dialog/confirm-dialog.component';

import { AccountService } from '../../services/account.service';
import { CacheService } from '../../global/ng2-cache/services/cache.service';
import { SessionService } from '../../services/session2.service';
import { ErrorService } from '../../services/error.service';
import { GlobalMessageService } from '../../services/global-message.service';

@Component({
  selector: 'app-settings-contact',
  templateUrl: './settings-contact.component.html'
  // host: { '[@routerTransition]': 'true' },
  // animations: Animations.page
})
export class SettingsContactComponent implements OnInit {

	loadingPage: boolean = true;
  accountData: any = {};
  ignoreDomain: string = '';

  addDomainDialogRef: BsModalRef;

  constructor(private accountService: AccountService,
              private cacheService: CacheService,
              private sessionService: SessionService,
              private errorService: ErrorService,
              private modalService: BsModalService,
              private globalMessageService: GlobalMessageService) { }

  ngOnInit() {
    if (!this.cacheService.get('session')) {
      this.sessionService.getSession(true).subscribe(
        (session: any) => {
          this.initView();
        }
      )
    }
    else {
      this.initView();
    }
  }

  newDomain(dialog) {
    this.addDomainDialogRef = this.modalService.show(dialog, {class: 'modal-md'});
  }

  addDomain() {
    this.addDomainDialogRef.hide();
    this.ignoreDomain = this.ignoreDomain.toLowerCase();
    this.accountService.addIgnoreDomain(this.ignoreDomain).subscribe(
      (result: any) => {
      this.accountData.ignore_domains.push(this.ignoreDomain);
      this.globalMessageService.message('Domain was added to your ignore list');
    },
    err => {
      this.globalMessageService.error();
      this.errorService.log(err, 'settings-contact.component', 'newDomain');
    });
  }

  removeDomain(domain) {
    let me = this;
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, {
      initialState: {
        message: 'Please confirm you would like to delete this domain from your ignore list',
        confirm: function() {
          me.accountService.removeIgnoreDomain(domain).subscribe(
            (result: any) => {
              me.globalMessageService.message('Domain was removed from your ignore list');
              for (var idx = 0; idx < me.accountData.ignore_domains.length; idx++) {
                if (me.accountData.ignore_domains[idx] == domain) {
                  me.accountData.ignore_domains.splice(idx, 1);
                  break;
                }
              }
            },
            err => {
              me.globalMessageService.error();
              me.errorService.log(err, 'settings-contact.component', 'removeDomain');
            }
          );
        }
      }
    }));
  }

  private initView() {
  	this.loadingPage = true;
  	this.accountService.getAccount().subscribe(
      (result: any) => {
  		this.accountData = result;
      this.loadingPage = false;
  	},
    err => {
      this.globalMessageService.error();
      this.errorService.log(err, 'settings-domains.component', 'ngOnInit');
    });
  }

}



// WEBPACK FOOTER //
// ./client/app/settings/settings-contact/settings-contact.component.ts